import { Component, computed, input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'pu-status',
  template: '{{ (i18nPrefix() + \'.\' + type()) | translate }}',
  styleUrls: ['./status.component.scss'],
  host: {
    '[class]': 'hostClasses()',
  },
})
export class StatusComponent {
  type = input.required<string>();
  i18nPrefix = input.required<string>();

  readonly hostClasses = computed(() => `pu-status pu-status_${this.type()}`);

  statusType: string;
}
